var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenancedet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 686.711,
    height: 544.068,
    viewBox: "0 0 686.711 544.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M0,49.536H686.711V-494.532H0Z",
    transform: "translate(0 494.532)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876",
    transform: "translate(0 494.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(0 -494.532)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(0 76.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M12.147,9.036,18.5-16.539,2.433-20.533a54.448,54.448,0,0,0-2.665-15.2L14.3-44.485.712-67.065l-14.871,8.952a54.38,54.38,0,0,0-12.053-8.852l4.2-16.892-25.577-6.356L-51.72-73.6a54.455,54.455,0,0,0-15.172,1.946l-8.644-14.361L-98.117-72.422l8.242,13.694A54.516,54.516,0,0,0-99.921-45.97l-14.988-3.725-6.357,25.577,14.141,3.515a54.341,54.341,0,0,0,2.2,17.123l-12.143,7.306,13.592,22.583,11.8-7.1A54.523,54.523,0,0,0-77.437,29.881L-80.746,43.2l25.577,6.357,3.379-13.6a54.421,54.421,0,0,0,17.154-2.915l7.412,12.315L-4.644,31.765l-7.814-12.98A54.443,54.443,0,0,0-3.076,5.254ZM-27.782-6.674a26.951,26.951,0,0,1-3.23,4.985A27.375,27.375,0,0,1-44.693,7.4a26.98,26.98,0,0,1-4.8.957,27.147,27.147,0,0,1-9.445-.564,27.116,27.116,0,0,1-7.851-3.461,27,27,0,0,1-3.622-2.7A27.379,27.379,0,0,1-79.188-13.66a27.076,27.076,0,0,1-.47-5.029,27.242,27.242,0,0,1,.721-6.74,27.223,27.223,0,0,1,3.922-8.612,27.282,27.282,0,0,1,3.97-4.753,27.4,27.4,0,0,1,12.3-6.555,26.977,26.977,0,0,1,7.172-.846,27.262,27.262,0,0,1,5.85.772A27.184,27.184,0,0,1-39.426-42.9a27.1,27.1,0,0,1,6.116,4.5,27.417,27.417,0,0,1,6.868,10.7,27.271,27.271,0,0,1,1.332,6.948,27.035,27.035,0,0,1-.616,8.557,27.275,27.275,0,0,1-2.056,5.53",
    transform: "translate(121.265 90.213)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(541.476 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M7.976,6.669l6.772-16.793L4.2-14.38a37.377,37.377,0,0,0-.358-10.6l10.727-4.561L7.477-46.2-3.5-41.535a37.452,37.452,0,0,0-7.355-7.176L-6.379-59.8l-16.794-6.773-4.4,10.908a37.408,37.408,0,0,0-10.509-.127l-4.507-10.6L-59.251-59.3l4.3,10.106a37.438,37.438,0,0,0-8.055,7.72l-9.841-3.968-6.772,16.793,9.284,3.745A37.393,37.393,0,0,0-70.48-13.05l-8.959,3.811,7.085,16.663,8.711-3.7a37.36,37.36,0,0,0,8.674,8.557L-58.5,21.024l16.794,6.77,3.6-8.927a37.464,37.464,0,0,0,11.95-.342l3.865,9.087,16.663-7.087L-9.7,10.947A37.426,37.426,0,0,0-2.019,2.639ZM-17.687-7.84a18.729,18.729,0,0,1-2.675,3.083A18.812,18.812,0,0,1-30.54.115,18.673,18.673,0,0,1-33.9.306,18.632,18.632,0,0,1-40.272-.982a18.651,18.651,0,0,1-5.01-3.106,18.392,18.392,0,0,1-2.206-2.184,18.806,18.806,0,0,1-4.506-11.242,18.621,18.621,0,0,1,.162-3.466A18.724,18.724,0,0,1-50.7-25.5a18.658,18.658,0,0,1,3.492-5.483,18.745,18.745,0,0,1,3.156-2.854,18.824,18.824,0,0,1,9-3.283,18.579,18.579,0,0,1,4.961.11,18.894,18.894,0,0,1,3.907,1.086,18.69,18.69,0,0,1,4.04,2.315,18.642,18.642,0,0,1,3.731,3.646,18.836,18.836,0,0,1,3.649,7.934,18.715,18.715,0,0,1,.242,4.855,18.665,18.665,0,0,1-1.237,5.764A18.929,18.929,0,0,1-17.687-7.84",
    transform: "translate(79.622 66.574)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M196.471.923H413.046V-9.212H196.471Z",
    transform: "translate(19.68 48.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(0 -494.532)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(61.479 137.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M48.2,26.992H-481.169v-268.8a27.658,27.658,0,0,1,27.658-27.658H20.54A27.657,27.657,0,0,1,48.2-241.809Z",
    transform: "translate(481.169 269.467)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(61.48 434.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M45.69,4.62H-428.591a27.543,27.543,0,0,1-27.543-27.543v-23.2H73.233v23.2A27.543,27.543,0,0,1,45.69,4.62",
    transform: "translate(456.134 46.12)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M562.372-353.552H72.068V-92.567h490.3Z",
    transform: "translate(7.219 14.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M350.334-69.94H252.427V-82.2h97.907Z",
    transform: "translate(25.285 41.302)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(260.427 -9.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M11.97,4.438H-119.5l6.915-48.745H5.056Z",
    transform: "translate(119.501 44.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(266.581 -9.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M10.85.489H-108.315l.76-5.375H10.125Z",
    transform: "translate(108.315 4.886)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M487.51-116.864H410.584v-76.925H487.51Z",
    transform: "translate(41.127 30.125)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M483.376-121H414.029v-69.348h69.347Z",
    transform: "translate(41.472 30.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(0 -494.532)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(455.5 356.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M5.514,1.754A8.2,8.2,0,0,0-8.924,1.743c-3.847,6.693-8.1,13.887-9.647,15.773h-1.034c-2.787-4.167-11.6-35.49-20.66-35.025-8.488.437-14.014,30.975-14.709,35.025h-.076v12H14.3V17.969Z",
    transform: "translate(55.051 17.514)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(498.82 345.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M1.431.716A7.862,7.862,0,0,1-6.43,8.577,7.861,7.861,0,0,1-14.29.716a7.86,7.86,0,0,1,7.86-7.86A7.861,7.861,0,0,1,1.431.716",
    transform: "translate(14.29 7.144)",
    fill: "#f2a51c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M487.51-192.048H410.584v-76.925H487.51Z",
    transform: "translate(41.127 22.594)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M483.376-196.181H414.029V-265.53h69.347Z",
    transform: "translate(41.472 22.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(0 -494.532)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(455.5 274.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M5.514,1.754A8.2,8.2,0,0,0-8.924,1.743c-3.847,6.693-8.1,13.889-9.647,15.774h-1.034c-2.787-4.167-11.6-35.491-20.66-35.026-8.488.437-14.014,30.975-14.709,35.026h-.076v12H14.3V17.969Z",
    transform: "translate(55.051 17.514)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(498.82 262.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M1.431.716A7.861,7.861,0,0,1-6.43,8.575,7.86,7.86,0,0,1-14.29.716,7.86,7.86,0,0,1-6.43-7.145,7.861,7.861,0,0,1,1.431.716",
    transform: "translate(14.29 7.145)",
    fill: "#f2a51c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(526.457 -254.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M.1,0V1.09H-.991V3.271H2.28V0Z",
    transform: "translate(0.991)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M420.714-275.226h-4.268v2.181h4.268Zm8.537,0h-4.268v2.181h4.268Zm8.537,0h-4.269v2.181h4.269Zm8.536,0h-4.268v2.181h4.268Zm8.537,0h-4.269v2.181h4.269Zm8.537,0h-4.269v2.181H463.4Zm8.536,0h-4.269v2.181h4.269Zm8.537,0H476.2v2.181h4.269Z",
    transform: "translate(41.714 21.967)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(450.621 -254.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M.3.1H-.792V-.991H-2.973V2.28H.3Z",
    transform: "translate(2.973 0.991)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M411.773-338.294h-2.18v4.269h2.18Zm0,4.269,0,4.269h-2.18v4.268h2.18Zm0,4.267,0,4.269h-2.18v4.269h2.18Zm0,4.269,0,4.269h-2.18v4.268h2.18Zm0,4.268,0,4.269h-2.18v4.269h2.18Zm0,4.269,0,4.269h-2.18v4.269h2.18Zm0,4.267,0,4.269h-2.18v4.269h2.18Zm0,4.269,0,4.269h-2.18v4.268h2.18Z",
    transform: "translate(41.028 15.65)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(450.621 -330.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M.2.3V-.792h1.09V-2.973H-1.982V.3Z",
    transform: "translate(1.982 2.973)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M476.2-342.966h4.269v-2.181H476.2Zm-8.537,0h4.269v-2.181h-4.269Zm-8.537,0H463.4v-2.181H459.13Zm-8.536,0h4.269v-2.181h-4.269Zm-8.537,0h4.268v-2.181h-4.268Zm-8.537,0h4.268v-2.181H433.52Zm-8.536,0h4.268v-2.181h-4.268Zm-8.537,0h4.268v-2.181h-4.268Z",
    transform: "translate(41.714 14.963)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(526.457 -330.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M0,.2H1.09v1.09H3.271V-1.982H0Z",
    transform: "translate(0 1.982)",
    fill: "#3a3ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M479.515-274.267H481.7v-4.269h-2.181Zm0-4.269,0-4.267H481.7v-4.269h-2.181Zm0-4.269,0-4.268H481.7v-4.269h-2.181Zm0-4.269,0-4.268H481.7v-4.269h-2.181Zm0-4.269,0-4.269H481.7v-4.269h-2.181Zm0-4.269,0-4.269H481.7v-4.269h-2.181Zm0-4.268,0-4.269H481.7v-4.269h-2.181Zm0-4.269,0-4.268H481.7V-338.3h-2.181Z",
    transform: "translate(48.032 15.65)",
    fill: "#3a3ae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M55.826-121.391h.062V-233.075h-.062Z",
    transform: "translate(5.592 26.19)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M73.688-233.074H55.882V-121.39H73.688Z",
    transform: "translate(5.598 26.19)",
    fill: "#21118e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M139.358-233.074H72.067V-121.39h67.291Z",
    transform: "translate(7.219 26.19)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M142.34-124.639H1.407V-238.95H142.34Z",
    transform: "translate(0.141 25.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M91.108-142.1H7.809V-150.7h83.3Z",
    transform: "translate(0.782 34.441)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M126.518-142.1H89.047V-150.7h37.471Z",
    transform: "translate(8.92 34.441)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0 -494.532)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(34.998 296.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M3.37,6.74A37.056,37.056,0,0,1-33.645-30.276,37.056,37.056,0,0,1,3.37-67.291,37.056,37.056,0,0,1,40.386-30.276,37.057,37.057,0,0,1,3.37,6.74m0-69.824A32.847,32.847,0,0,0-29.438-30.276,32.847,32.847,0,0,0,3.37,2.533,32.848,32.848,0,0,0,36.179-30.276,32.847,32.847,0,0,0,3.37-63.084",
    transform: "translate(33.645 67.291)",
    fill: "#f2a51c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(61.418 -175.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M2.313,1.335l-25.4-14.664V16Z",
    transform: "translate(23.087 13.329)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M419.893-375.075H115.434v6.566H419.893Z",
    transform: "translate(11.563 11.966)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M419.893-369.107H115.434v17.113H419.893Z",
    transform: "translate(11.563 12.563)",
    fill: "#21118e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M419.893-353.552H115.434v105.794H419.893Z",
    transform: "translate(11.563 14.122)",
    fill: "#d3d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M415.261-243.564H100.539v-205.11H415.261Z",
    transform: "translate(10.071 4.593)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M396-260.321H116.588V-434.714H396Z",
    transform: "translate(11.678 5.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M383.048-403.326H123.106V-419.28H383.048Z",
    transform: "translate(12.331 7.538)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M250.171-369.981H123.106v-15.953H250.171Z",
    transform: "translate(12.331 10.878)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(134.347 -376.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M11.668,1.552V.462H-114.306V-13.311H10.578V1.552h1.09v0h1.09V-15.492H-116.487V2.641H12.758V1.552Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M250.171-343.968H123.106v-15.954H250.171Z",
    transform: "translate(12.331 13.484)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(134.347 -347.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M11.668,1.552V.462H-114.306V-13.311H10.578V1.552h1.09v0h1.09V-15.492H-116.487V2.641H12.758V1.552Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M250.171-317.955H123.106v-15.953H250.171Z",
    transform: "translate(12.331 16.089)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(134.347 -318.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M11.668,1.552V.462H-114.306V-13.311H10.578V1.552h1.09v0h1.09V-15.492H-116.487V2.641H12.758V1.552Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M250.171-291.941H123.106v-15.953H250.171Z",
    transform: "translate(12.331 18.695)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(134.347 -290.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M11.668,1.552V.462H-114.306V-13.311H10.578V1.552h1.09v0h1.09V-15.492H-116.487V2.642H12.758V1.552Z",
    transform: "translate(116.487 15.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(0 -494.532)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(289.128 127.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M1.474,0A48.3,48.3,0,0,0-2.783,67.872L33.627,36.09Z",
    transform: "translate(14.717)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(337.472 116.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M4.324,3.509A48.377,48.377,0,0,0-34.393-35.033L-43.171,12.5Z",
    transform: "translate(43.171 35.033)",
    fill: "#e2e2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(305.319 115.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M3.727.074a48.6,48.6,0,0,0-8.779-.81A48.155,48.155,0,0,0-37.2,11.518l32.152,36.09Z",
    transform: "translate(37.205 0.736)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(301.061 163.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M0,2.894A48.218,48.218,0,0,0,36.41,19.454,48.145,48.145,0,0,0,56.8,14.944L36.41-28.888Z",
    transform: "translate(0 28.888)",
    fill: "#ceceff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(337.471 154.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M0,.819,20.393,44.65A48.341,48.341,0,0,0,48.344.819,48.513,48.513,0,0,0,47.5-8.173Z",
    transform: "translate(0 8.173)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(445.243 76.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M19.629,4.713H-170.079A25.881,25.881,0,0,1-195.96-21.169a25.88,25.88,0,0,1,25.881-25.879H19.629A25.878,25.878,0,0,1,45.508-21.169,25.88,25.88,0,0,1,19.629,4.713",
    transform: "translate(195.96 47.048)",
    fill: "#9b2dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(456.977 94.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M19.246,0H-185.723a6.414,6.414,0,0,0-6.414,6.414h0a6.414,6.414,0,0,0,6.414,6.414H19.246A6.414,6.414,0,0,0,25.66,6.415h0A6.414,6.414,0,0,0,19.246,0",
    transform: "translate(192.137)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(469.638 84.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M2.9,1.448A15.9,15.9,0,0,1-13,17.345a15.9,15.9,0,0,1-15.9-15.9A15.9,15.9,0,0,1-13-14.451,15.9,15.9,0,0,1,2.9,1.448",
    transform: "translate(28.902 14.451)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(168.313 277.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M3.343,0A36.718,36.718,0,1,0,40.062,36.718,36.718,36.718,0,0,0,3.343,0m0,60.658a23.94,23.94,0,1,1,23.941-23.94A23.94,23.94,0,0,1,3.343,60.658",
    transform: "translate(33.375)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(181.091 289.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M2.18,4.359A23.94,23.94,0,0,1-21.76-19.58,23.939,23.939,0,0,1,2.18-43.521,23.94,23.94,0,0,1,26.12-19.58,23.941,23.941,0,0,1,2.18,4.359",
    transform: "translate(21.76 43.521)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(205.032 277.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M0,0V12.777A23.941,23.941,0,0,1,23.94,36.718a24.069,24.069,0,0,1-.469,4.71L33.59,51.547a36.576,36.576,0,0,0,3.128-14.829A36.718,36.718,0,0,0,0,0",
    transform: "translate(0)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(262.645 277.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M3.343,0A36.718,36.718,0,1,0,40.061,36.718,36.718,36.718,0,0,0,3.343,0m0,60.658a23.94,23.94,0,1,1,23.941-23.94A23.941,23.941,0,0,1,3.343,60.658",
    transform: "translate(33.375)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(299.362 277.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M1.471,1.742,9.252-8.468C4.006-13.394-6.845-17.89-14.69-17.35V-4.573A23.822,23.822,0,0,1,1.471,1.742",
    transform: "translate(14.69 17.394)",
    fill: "#f2a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(275.422 289.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M2.549,4.329A23.97,23.97,0,0,1-25.114-23.333,23.928,23.928,0,0,1-5.56-42.886,23.971,23.971,0,0,1,22.1-15.223,23.928,23.928,0,0,1,2.549,4.329",
    transform: "translate(25.447 43.219)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(368.685 288.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M2.549,4.329A23.971,23.971,0,0,1-25.114-23.333,23.926,23.926,0,0,1-5.561-42.886,23.97,23.97,0,0,1,22.1-15.223,23.93,23.93,0,0,1,2.549,4.329",
    transform: "translate(25.447 43.219)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(355.908 276.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M3.343,0A36.718,36.718,0,1,0,40.061,36.719,36.719,36.719,0,0,0,3.343,0m0,60.659a23.94,23.94,0,1,1,23.941-23.94A23.94,23.94,0,0,1,3.343,60.659",
    transform: "translate(33.375)",
    fill: "#140577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(392.626 276.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M3.343,3.343A36.719,36.719,0,0,0-33.375-33.375V-20.6A23.94,23.94,0,0,1-9.435,3.343,23.921,23.921,0,0,1-23.167,24.975l9.612,9.27a36.677,36.677,0,0,0,16.9-30.9",
    transform: "translate(33.375 33.375)",
    fill: "#9b2dff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M226.563-160.148H151.617v-6.6h74.946Z",
    transform: "translate(15.187 32.833)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M226.563-148.311H151.617v-6.6h74.946Z",
    transform: "translate(15.187 34.019)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M226.563-136.475H151.617v-6.6h74.946Z",
    transform: "translate(15.187 35.205)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M371.306-160.148H322.031v-6.6h49.276Z",
    transform: "translate(32.257 32.833)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M396.977-148.311H322.031v-6.6h74.946Z",
    transform: "translate(32.257 34.019)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M352.512-136.475H322.031v-6.6h30.481Z",
    transform: "translate(32.257 35.205)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M313.678-160.148H238.732v-6.6h74.946Z",
    transform: "translate(23.913 32.833)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M289.847-148.311H238.731v-6.6h51.116Z",
    transform: "translate(23.913 34.019)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M313.678-136.475H238.732v-6.6h74.946Z",
    transform: "translate(23.913 35.205)",
    fill: "#140577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M615.855-291.315H548.53v-67.326h67.325Z",
    transform: "translate(54.945 13.612)",
    fill: "#9b2dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M611.01-296.32H552.669v-58.34H611.01Z",
    transform: "translate(55.36 14.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(0 -494.532)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(614.995 161.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M1.264,3.523H1.23a1.693,1.693,0,0,1-1.3-.65l-12.2-15.716a1.684,1.684,0,0,1,.3-2.364,1.685,1.685,0,0,1,2.364.3L1.318-.839,29.791-34.574a1.685,1.685,0,0,1,2.375-.2,1.686,1.686,0,0,1,.2,2.374L2.551,2.925a1.682,1.682,0,0,1-1.287.6",
    transform: "translate(12.619 35.173)",
    fill: "#9b2dff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenancedet);
export default __webpack_public_path__ + "static/media/maintenancedet.88c5d8b54ee2f41fe599eb3bf5a69be3.svg";
export { ForwardRef as ReactComponent };